import React, { useEffect, useState } from "react";
import { Input } from "antd";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getRequest } from "../../api/http";
import userapiservice from "../../api/userapiservice";
import { sortDataByOrder } from "../../utils/helper";
import { CloseActive, SearchZoomActive } from "../../components/Icons/Icons";
import Loader from "../../components/Loader/Loader";
import ToastComponent from "../../components/ToastCompoent/ToastComponent";
import CardList from "./newUx/CardList/CardList";
import './news.scss';
import { inputFieldCharLimit } from "../../config";

const color = ["#E75E0D", "#EB9F11", "#ABC710", "#009340", "#CC0370", "#8366A9", "#149BD7"];

const News = ({ activeKey = "news_tab" }) => {
    const localData = useSelector((state) => state?.localStorage)
    const navigate = useNavigate();
    const { micrositeID, tabConfigId } = localData
    const id = micrositeID;

    const [mediaType, setMediaType] = useState("");

    const [loading, setLoading] = useState(true);
    const [responseData, setResponseData] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [videoUrl, setVideoUrl] = useState("");
    const [textSearch, setTextSearch] = useState('')

    const onCardClickHandler = (data, id) => {
        if (activeKey === "news_tab") {
            navigate(`/microsite/${data.id}/micrositeDetails`, {
                state: { page: activeKey, data: data },
            });
        }
        else {

            window.location.replace(data.urlLink);
        }
    };

    const getServicesData = async (activeKey, id, searchKeyword) => {
        try {
            setLoading(true);

            if (!id) return;

            let response;
            let data;

            if (searchKeyword === "") {
                // call GET API
                response = await getRequest(
                    userapiservice.getMicrositeDetailsTabs(id, tabConfigId),
                    null,
                    false
                );
                data = response;
            } else {
                // call POST API
                const paramData = {
                    id: id,
                    tabConfigId: tabConfigId,
                };

                const text = searchKeyword;

                try {
                    const fetchResponse = await fetch(
                        userapiservice.getNewsByDate(paramData), // paramData goes in URL
                        {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify({ text }), // payload body
                        },
                        false
                    );

                    console.log("response.status", fetchResponse.status);
                    data = await fetchResponse.json();

                    if (data === "Success") {
                        toast.success("Reset link has been sent to your mail");
                    } else if (fetchResponse.status === 400) {
                        const match = data.message?.match(/\{"errors":\[.*\]\}/);
                        if (match) {
                            const parsed = JSON.parse(match[0]);
                            if (parsed.errors && Array.isArray(parsed.errors) && parsed.errors.length > 0) {
                                toast.error(parsed.errors[0].message);
                            }
                        } else if (data.error) {
                            toast.error(data.error);
                        } else {
                            toast.error("Invalid request. Please check your details and try again.");
                        }
                    }
                } catch (error) {
                    console.error("Error fetching news:", error);
                    throw error;
                }
            }

            // Normalize response data (only if `data` is an array)
            if (Array.isArray(data)) {
                const responseWithTabType = data.map((res) => ({
                    ...res,
                    type: activeKey === "news_tab" ? "NEWS_TAB" : "PRESS",
                }));
                setResponseData(sortDataByOrder(responseWithTabType));
            } else {
                console.warn("Expected array response, got:", data);
                setResponseData([]);
            }
        } catch (error) {
            const apiErrorMessage =
                error?.response?.data?.errorName ||
                error?.response?.data?.message ||
                error?.message ||
                "Sorry, something went wrong";

            toast.error(<ToastComponent type="Error" message={apiErrorMessage} />);
        } finally {
            setLoading(false);
        }
    };


    const getPlaceholder = (activeKey) => {
        switch (activeKey) {
            case 'news_tab':
                return "Search Blog"
            case 'press':
                return "Search Articles"
            default:
                return "Search"
        }
    }

    const PlayVideoHandler = (url, mediaType) => {
        setMediaType(mediaType)
        setVideoUrl(url);
        setIsModalOpen(true);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        setVideoUrl("");
    };

    const convertToStandardURL = (shortUrl) => {
        if (shortUrl?.indexOf('youtu.be') !== -1) {
            const video_id = shortUrl?.split('youtu.be/')[1].split('?')[0];
            return `https://www.youtube.com/watch?v=${video_id}`;
        }
        return shortUrl;
    }

    useEffect(() => {
        // debouncing
        const handler = setTimeout(() => {
            getServicesData(activeKey, id, textSearch)
        }, 500)
        return () => {
            clearTimeout(handler)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeKey, id, textSearch]);

    return <div className="news-container" >
        <div className="search-container" >
            <Input
                // className="title-bar-search"
                placeholder={getPlaceholder(activeKey)}
                maxLength={inputFieldCharLimit}
                prefix={
                    <SearchZoomActive style={{ color: "#CC0E2D", verticalAlign: "middle" }} />
                }
                suffix={textSearch.length > 0 && <span
                    onClick={() => setTextSearch('')}
                    className="btn btn-sm p-0 d-flex align-items-center">
                    <CloseActive customClassName={"search-clear-btn"} />
                </span>}
                // type="Date"
                value={textSearch}
                onChange={(e) =>
                    setTextSearch(e.target.value)
                }
                style={{ maxWidth: '300px' }}
            />
        </div>

        {loading ? <Loader /> : <>
            <CardList
                responseData={responseData}
                color={color}
                PlayVideoHandler={PlayVideoHandler}
                convertToStandardURL={convertToStandardURL}
                isModalOpen={isModalOpen}
                handleCancel={handleCancel}
                videoUrl={videoUrl}
                mediaType={mediaType}
                onCardClickHandler={onCardClickHandler}
            />
            {
                !loading && responseData.length === 0
            }
        </>}
    </div>


}

export default News